import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import React, { useEffect } from "react";
import CareerCard from "../components/CareerCard";

gsap.registerPlugin(ScrollTrigger);
const Careers = () => {
  // For Content Div animation
  useEffect(() => {
    gsap.utils.toArray(".content-box").forEach((box) => {
      gsap.fromTo(
        box,
        {
          x: -3000, // Starting position: 200px off-screen to the left
          opacity: 0, // Starting opacity
        },
        {
          x: 0, // End position: original position
          opacity: 1, // Fully visible
          duration: 1.7, // Animation duration
          ease: "power4.inout", // Smooth easing
          scrollTrigger: {
            trigger: box, // Each box triggers its own animation
            start: "top 80%", // Animation starts when the box enters the viewport
            toggleActions: "play none none none", // Play animation only once
          },
        }
      );
    });

    // Second set of animations for '.cylinder'
    gsap.utils.toArray(".cylinder").forEach((box) => {
      gsap.fromTo(
        box,
        {
          x: -1000, // Starting position: 200px off-screen to the top
          opacity: 0, // Starting opacity
        },
        {
          x: 0, // End position: original position
          opacity: 1, // Fully visible
          duration: 1.5, // Animation duration
          ease: "power.inOut", // Smooth easing
          scrollTrigger: {
            trigger: box, // Each cylinder triggers its own animation
            start: "top 80%", // Animation starts when the cylinder enters the viewport
            toggleActions: "play none none none", // Play animation only once
          },
        }
      );
    });

    // Button Hover
    gsap.utils.toArray(".career-button").forEach((button) => {
      const text1 = button.querySelector(".button-text-1"); // First text
      const text2 = button.querySelector(".button-text-2"); // Second text

      // Initially, make the second text invisible and positioned below
      gsap.set(text2, { y: "-20px", opacity: 0 });

      // Hover in animation (move the first text up and second text down into place)
      button.addEventListener("mouseenter", () => {
        gsap.to(text1, {
          y: "-20px", // Move the first text up
          opacity: 0, // Fade out the first text
          duration: 1,
          ease: "power4.out",
        });
        gsap.to(text2, {
          y: "0px", // Move the second text into place
          opacity: 1, // Fade in the second text
          duration: 1,
          ease: "power4.out",
        });
      });

      // Hover out animation (move the first text back down and second text up)
      button.addEventListener("mouseleave", () => {
        gsap.to(text1, {
          y: "0px", // Reset the position of the first text
          opacity: 1, // Fade in the first text
          duration: 1,
          ease: "power4.in",
        });
        gsap.to(text2, {
          y: "20px", // Move the second text back down
          opacity: 0, // Fade out the second text
          duration: 1,
          ease: "power4.in",
        });
      });
    });
  }, []);

  const careerCards = [
    {
      id: 1,
      title: "IT Consulting",
      subTitle:
        '"Occupy your resource and unlock new paradigms with our IT solutions."',
      description:
        "Param Consulting Services Inc., founded in 2001, delivers cost-effective IT solutions and staffing services, meeting diverse client needs with advanced technology and expertise.",
      url: "https://pcsionweb.com/",
    },
    {
      id: 2,
      title: "Healthcare Services",
      subTitle:
        '"Committed to taking care of your every medical need. We offer a diverse wellness portfolio of services to relieve your worries."',
      description:
        "Param Healthcare Services simplifies the journey to quality medical care by offering all essential services in one place. From adult daycare to medical billing and home healthcare, we’ve got you covered, making healthcare convenient and accessible.",
      url: "https://paramhealthcareservices.com/",
    },
    {
      id: 3,
      title: "Institute Of Education",
      subTitle:
        '"Get trained with us and your fineness will attract opportunities for life."',
      description:
        "Param Institute of Education, founded in 2009, offers quality medical training with a promise of employment. With over two decades of experience, it empowers students to excel in healthcare careers.",
      url: "https://paramedu.com/",
    },
    {
      id: 4,
      title: " Adult Day Care",
      subTitle:
        '"A home away from home/ Parents are not the burden, burden is the care and attention that follow. Make your parents happy by giving the best services and care."',
      description:
        "Param Adult Day Care, a not-for-profit organization, provides senior citizens with a safe, friendly, and engaging environment to enjoy their golden years. With experienced staff and comprehensive healthcare and social activities, we offer families peace of mind while caring for their loved ones.",
      url: "https://www.paramadultdaycares.com/",
    },
    {
      id: 5,
      title: "Wellness",
      subTitle:
        '"Find your inner peace and discover the holistic ways of wellness."',
      description:
        "Param Wellness, a US-based organization, blends Ayurveda and natural healing to rejuvenate mind, body, and spirit. Offering therapies like acupuncture, yoga, and homeopathy, we promote holistic health through integrative and time-tested approaches.",
      url: "https://paramwellness.com/",
    },
    {
      id: 6,
      title: "Care Foundation",
      subTitle:
        '"Join us in our mission to spread awareness, motivate people and transform lives."',
      description:
        "ParamCARE Foundation, based in New Jersey, promotes healthy living through seminars, yoga, and screenings. The foundation educates the community on lifestyle choices to help improve health and manage chronic illnesses.",
      url: "https://paramcare.org/",
    },
    {
      id: 7,
      title: "Research & Development",
      subTitle:
        '"Each day we get one step closer to finding solutions to improve your health and lifestyle"',
      description:
        " Research & Development focuses on developing natural treatments for chronic diseases through innovative drug testing. With a dedicated team, we integrate science and wellness to improve healthcare solutions for conditions like Alzheimer's and diabetes.",
      url: "https://drbbthakar.com/",
    },
  ];

  return (
    <div className="h-full w-full flex  justify-center items-center  -z-50">
      <div className="w-[95%] flex flex-col justify-center items-center md:gap-[60px] xs:gap-[79px] lg:mb-[120px] md:mb-[70px] xs:mb-[53px]">
        {/* <div className="bg-careers-bg h-[440px] w-full  bg-center bg-cover object-cover opacity-95 rounded-[110px] flex flex-col justify-center items-center mt-20  font-faustina text-white gap-4 relative mb-[60px]">
            <div className=" absolute inset-0 bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  opacity-15 rounded-[110px]"></div>
            <div className="z-50 flex  flex-col justify-center items-center">
              <p className="font-bold text-6xl leading-20">Come Work With Us</p>
              <p className="font-medium text-3xl leading-10">
                {" "}
                "You Are Standing At The Door Of Opportunities, Explore Your
                Professional Journey With Us"
              </p>
            </div>
          </div> */}

        {/*  ---------------------------------------------- Background image of Career ---------------------------------------------- */}

        <div className="font-faustina h-auto xs:h-[200px] lg:h-[350px] md:h-[313px] sm:h-[280px]  w-full md:mt-[60px] xs:mt-[40px] bg-careers-bg lg:rounded-[110px] md:rounded-[67px] xs:rounded-[50px] text-[#EEEEEE] flex flex-col justify-center items-center relative bg-cover bg-center bg-no-repeat">
          <div className="bg-inner absolute inset-0 bg-gradient-to-r from-[#1FA2FF] from-[0%] via-25% to-[#A6FFCB] to-[70%] opacity-20 lg:rounded-[110px] md:rounded-[67px] xs:rounded-[50px]"></div>
          <p className="font-bold md:text-[50px] xs:text-[32px] mg-[10px]">
            Come Work With Us
          </p>
          <p className="font-medium md:text-[24px] xs:text-[18px] text-center px-10">
            You stand at the door of opportunities. Begin your professional journey with us.
          </p>
        </div>

        {/*  ----------------------- -----------------------Career Box Main div ----------------------- ----------------------- */}

        <div className="flex flex-col lg:gap-[40px] md:gap-[60px] xs:gap-[33px] justify-center items-center w-[100%]">
          {/* ----------------------- ----------------------- IT Consulting  ----------------------- -----------------------*/}

          {careerCards.map((career, i) => {
            return (
              <CareerCard
                id={career.id}
                title={career.title}
                subtitle={career.subTitle}
                description={career.description}
                path={career.url}
              />
            )
          })}

          {/*  ----------------------- -----------------------Param Healthcare Services ----------------------- ----------------------- */}
          {/* <div className="flex justify-start h-full w-full">
            <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px]  xs:w-4  md:w-7 cylinder"></div>

            <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
              <div className="bg-black rounded-[15px] ">
                <div className="flex flex-col py-8 px-10  md:gap-8 xs:gap-[15px]">
                  <div className="  text-white">
                    <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                      Healthcare Services
                    </h2>
                  </div>
                  <div className="text-justify text-white mt-1 md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                    <p className="font-poppins font-semibold ">
                      "We are committed to taking care of your every medical
                      need. Our diverse wellness portfolio offers services
                      designed to relieve your worries."
                    </p>
                    <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                      Param Healthcare Services simplifies your journey to
                      quality medical care by offering all essential services in
                      one place. From adult daycare to medical billing and home
                      healthcare, we’ve got you covered—making healthcare
                      convenient and accessible.
                    </p>
                  </div>
                  
                  <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                    <button className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                      <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                        VISIT CAREER
                      </span>
                      <span className="new-text absolute ">VISIT CAREER</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/*  ----------------------- -----------------------Param Institute Of Education ----------------------- ----------------------- */}
          {/* <div className="flex justify-start h-full w-full content-box">
            <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px] xs:w-4  md:w-7 cylinder"></div>

            <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
              <div className="bg-black rounded-[15px] ">
                <div className="flex flex-col py-8 px-10  md:gap-8 xs:gap-[15px]">
                  <div className="text-white">
                    <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                      Institute Of Education
                    </h2>
                  </div>
                  <div className="text-justify text-white md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                    <p className="font-poppins font-semibold ">
                      "Get trained with us, and your excellence will attract
                      lifelong opportunities."
                    </p>
                    <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                      Founded in 2009, Param Institute of Education offers
                      quality medical training with a promise of employment.
                      Backed by over two decades of experience, it empowers
                      students to excel in healthcare careers.
                    </p>
                  </div>
                  
                  <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                    <button className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                      <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                        VISIT CAREER
                      </span>
                      <span className="new-text absolute ">VISIT CAREER</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/*  ----------------------- -----------------------Param Adult Day Care ----------------------- ----------------------- */}
          {/* <div className="flex justify-start h-full w-full">
            <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px] xs:w-4  md:w-7 cylinder"></div>

            <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
              <div className="bg-black rounded-[15px] ">
                <div className="flex flex-col py-8 px-10  md:gap-8 xs:gap-[15px]">
                  <div className="  text-white">
                    <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                      Adult Day Care
                    </h2>
                  </div>
                  <div className="text-justify text-white md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                    <p className="font-poppins font-semibold ">
                      "A home away from home. Parents are not the burden—the
                      burden is the care and attention they require. Make your
                      parents happy by giving them the best services and care."
                    </p>
                    <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                      Param Adult Day Care, a not-for-profit organization,
                      provides senior citizens with a safe, friendly, and
                      engaging environment to enjoy their golden years. With
                      experienced staff and a comprehensive range of healthcare
                      and social activities, we offer families peace of mind
                      while caring for their loved ones.
                    </p>
                  </div>
                  
                  <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                    <button className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                      <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                        VISIT CAREER
                      </span>
                      <span className="new-text absolute ">VISIT CAREER</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* ----------------------- ----------------------- Param Wellness ----------------------- ----------------------- */}
          {/* <div className="flex justify-start h-full w-full">
            <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px] xs:w-4  md:w-7 cylinder"></div>

            <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
              <div className="bg-black rounded-[15px] ">
                <div className="flex flex-col py-8 px-10  md:gap-8 xs:gap-[15px]">
                  <div className="  text-white">
                    <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                      Wellness
                    </h2>
                  </div>
                  <div className="text-justify text-white md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                    <p className="font-poppins font-semibold ">
                      "Find your inner peace and discover holistic paths to
                      wellness. "
                    </p>
                    <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                      Param Wellness, a US-based organization, blends Ayurveda
                      and natural healing to rejuvenate the mind, body, and
                      spirit. Offering therapies such as acupuncture, yoga, and
                      homeopathy, we promote holistic health through
                      integrative, time-tested approaches.
                    </p>
                  </div>
                  
                  <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                    <button className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                      <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                        VISIT CAREER
                      </span>
                      <span className="new-text absolute ">VISIT CAREER</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* ----------------------- ----------------------- Param Care Foundation ----------------------- ----------------------- */}
          {/* <div className="flex justify-start h-full w-full">
            <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px] xs:w-4  md:w-7 cylinder"></div>

            <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
              <div className="bg-black rounded-[15px] ">
                <div className="flex flex-col py-8 px-10  md:gap-8 xs:gap-[15px]">
                  <div className="  text-white">
                    <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                      Care Foundation
                    </h2>
                  </div>
                  <div className="text-justify text-white md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                    <p className="font-poppins font-semibold ">
                      "Join us in our mission to spread awareness, inspire
                      people, and transform lives. "
                    </p>
                    <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                      ParamCARE Foundation, based in New Jersey, promotes
                      healthy living through seminars, yoga sessions, and health
                      screenings. The foundation educates the community on
                      lifestyle choices to improve health and manage chronic
                      illnesses.
                    </p>
                  </div>
                  
                  <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                    <button className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                      <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                        VISIT CAREER
                      </span>
                      <span className="new-text absolute ">VISIT CAREER</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* ----------------------- ----------------------- Research & Development  ----------------------- -----------------------*/}
          {/* <div className="flex justify-start h-full w-full">
            <div className="bg-gradient-to-r from-[#A6FFCB] via-[#12D8FA] to-[#1FA2FF] rounded-[11px] xs:w-4  md:w-7 cylinder"></div>
            <div className="bg-gradient-to-r from-[#1FA2FF]  via-[#12D8FA]   to-[#A6FFCB]  p-1 rounded-[20px] -ml-2 my-2 w-full h-[80%] content-box">
              <div className="bg-black rounded-[15px] ">
                <div className="flex flex-col py-8 px-10  md:gap-8 xs:gap-[15px]">
                  <div className="text-white">
                    <h2 className="font-faustina font-bold md:text-[40px] xs:text-[clamp(24px,5.5vw,40px)]">
                      Research & Development
                    </h2>
                  </div>
                  <div className="text-justify text-white md:text-[20px] xs:text-[clamp(16px,2.7vw,20px)]">
                    <p className="font-poppins font-semibold ">
                      "Each day, we get one step closer to finding solutions
                      that improve your health and lifestyle."
                    </p>
                    <p className="font-poppins font-base md:pt-[10px] xs:pt-[15px]">
                      {" "}
                      Research & Development focuses on creating natural
                      treatments for chronic diseases through innovative drug
                      testing. With a dedicated team, we integrate science and
                      wellness to enhance healthcare solutions for conditions
                      such as Alzheimer's and diabetes.
                    </p>
                  </div>
                  
                  <div className="md:mt-[8px] xs:mt-[12px] flex justify-center items-center md:w-[155px] xs:w-[140px] md:h-[62px] xs:h-[50px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                    <button className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium  xs:text-[18px] md:text-[20px] diagonal text-xl text-center relative py-[16px] sm:py-[14px] px-[52px] sm:px-[45px]">
                      <span className="old-text absolute transition-all top-0 left-0 w-full h-full flex justify-center items-center text-white">
                        VISIT CAREER
                      </span>
                      <span className="new-text absolute ">VISIT CAREER</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </div>
  );
};

export default Careers;
